
$(document).ready(function() {

    // Interaktívne funkcie
    function initializeInteractions() {
        // Prepínanie medzi sekciami
        $('.skewed-button').on('click', function(e) {
            e.preventDefault(); // Zabráni default linku
            
            $('.skewed-button').removeClass('active');
            $(this).addClass('active');
            
            $('.calendar-section').addClass('d-none');
            
            const buttonId = $(this).attr('id');
            switch(buttonId) {
                case 'calendarBtn':
                    $('#calendarSection').removeClass('d-none');
                    break;
                case 'myReservationsBtn':
                    $('#myReservationsSection').removeClass('d-none');
                    break;
                case 'documentsBtn':
                    $('#documentsSection').removeClass('d-none');
                    break;
            }
        });

        // Request button funkcionalita
        $('.request-btn').on('click', function() {
            const email = $('.email-input').val();
            
            if (!email) {
                alert('Prosím zadajte email adresu');
                return;
            }
            
            if (!isValidEmail(email)) {
                alert('Prosím zadajte platnú email adresu');
                return;
            }
            
            $(this).prop('disabled', true).text('Odosielam...');
            
            setTimeout(() => {
                alert('Žiadosť bola úspešne odoslaná!');
                $(this).prop('disabled', false).text(venueData.reservationSections.calendar.note.submitButton);
                $('.email-input').val('');
            }, 2000);
        });



        // Submit request button
        $('.submit-request-btn').on('click', function() {
            const email = $('.email-input-field').val();
            
            if (!email) {
                alert('Prosím zadajte email adresu');
                return;
            }
            
            if (!isValidEmail(email)) {
                alert('Prosím zadajte platnú email adresu');
                return;
            }
            
            $(this).prop('disabled', true).text('Odosielam...');
            
            setTimeout(() => {
                alert('Žiadosť bola úspešne odoslaná!');
                $(this).prop('disabled', false).text('Odoslať žiadosť');
                $('.email-input-field').val('');
            }, 2000);
        });

        // Period search functionality
        $('.period-input').on('change', function() {
            filterReservationsByPeriod();
        });

        // Sorting functionality
        $('.past-sort-select').on('change', function() {
            sortReservations($(this).val());
        });

        // Initialize reservations view - hide cards after 3rd for all devices
        function initReservationsView() {
            // Hide all cards except first 3
            $('.past-reservations-list .reservation-card.past').each(function(index) {
                if (index >= 3) {
                    $(this).hide();
                }
            });
            
            // Show button if there are more than 3 cards total
            const totalCards = $('.past-reservations-list .reservation-card.past').length;
            if (totalCards > 3) {
                $('#showMoreBtn').text('Zobraziť ďalšie').removeClass('btn-less').addClass('btn-more').show();
            } else {
                $('#showMoreBtn').hide();
            }
        }

        // Show more/less button functionality for all devices
        $('#showMoreBtn').on('click', function() {
            const $button = $(this);
            const currentText = $button.text().trim();
            
            if (currentText === 'Zobraziť ďalšie') {
                console.log('Show more button clicked!');
                
                // Find hidden reservation cards
                const hiddenCards = $('.past-reservations-list .reservation-card.past:hidden');
                console.log('Hidden cards found:', hiddenCards.length);
                
                // Show next 3 hidden cards
                hiddenCards.slice(0, 3).fadeIn();
                
                // Check if any more cards are hidden after showing
                setTimeout(() => {
                    const remainingHidden = $('.past-reservations-list .reservation-card.past:hidden').length;
                    console.log('Remaining hidden cards:', remainingHidden);
                    
                    // If no more cards to show, change button text to "Show less"
                    if (remainingHidden === 0) {
                        $button.text('Zobraziť menej');
                        $button.removeClass('btn-more').addClass('btn-less');
                    }
                }, 100);
                
            } else if (currentText === 'Zobraziť menej') {
                console.log('Show less button clicked!');
                
                // Hide all cards except first 3
                $('.past-reservations-list .reservation-card.past').each(function(index) {
                    if (index >= 3) {
                        $(this).fadeOut();
                    }
                });
                
                // Change button back to "Show more"
                setTimeout(() => {
                    $button.text('Zobraziť ďalšie');
                    $button.removeClass('btn-less').addClass('btn-more');
                }, 300);
            }
        });

        // Initialize reservations view on load
        initReservationsView();

        function filterReservationsByPeriod() {
            const fromDate = $('.period-input').first().val();
            const toDate = $('.period-input').last().val();
            
            if (!fromDate || !toDate) {
                $('.reservation-card.past').show();
                return;
            }
            
            const from = new Date(fromDate);
            const to = new Date(toDate);
            
            $('.reservation-card.past').each(function() {
                const dateText = $(this).find('.reservation-date').text();
                const reservationDate = parseReservationDate(dateText);
                
                if (reservationDate >= from && reservationDate <= to) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
        }

        function sortReservations(sortBy) {
            const container = $('.past-reservations-list');
            const cards = container.find('.reservation-card.past').get();
            
            cards.sort(function(a, b) {
                if (sortBy === 'date') {
                    const dateA = parseReservationDate($(a).find('.reservation-date').text());
                    const dateB = parseReservationDate($(b).find('.reservation-date').text());
                    return dateB - dateA; // Najnovšie najprv
                } else if (sortBy === 'venue') {
                    const venueA = $(a).find('.reservation-date').text();
                    const venueB = $(b).find('.reservation-date').text();
                    return venueA.localeCompare(venueB);
                }
            });
            
            container.empty().append(cards);
        }

        function parseReservationDate(dateString) {
            // Parsovanie "Utorok 27.6.2025" na Date objekt
            const parts = dateString.split(' ');
            if (parts.length >= 2) {
                const datePart = parts[1]; // "27.6.2025"
                const dateComponents = datePart.split('.');
                if (dateComponents.length === 3) {
                    const day = parseInt(dateComponents[0]);
                    const month = parseInt(dateComponents[1]) - 1; // Mesiace sú 0-indexed
                    const year = parseInt(dateComponents[2]);
                    return new Date(year, month, day);
                }
            }
            return new Date();
        }
    }

    // Helper function pre validáciu emailu
    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    // Inicializácia interakcií
    initializeInteractions();
    
    // Login Modal functionality
    initializeLoginModal();
    
    // Details Modal functionality
    initializeDetailsModal();
});

// Login Modal functions
function initializeLoginModal() {
    const loginTrigger = $('#loginTrigger');
    const loginModal = $('#loginModal');
    const closeModal = $('#closeModal');
    const togglePassword = $('#togglePassword');
    const passwordInput = $('#password');
    const loginForm = $('.login-form');

    // Open modal
    loginTrigger.on('click', function(e) {
        e.preventDefault();
        loginModal.addClass('active');
        $('body').css('overflow', 'hidden');
    });

    // Close modal
    closeModal.on('click', function() {
        loginModal.removeClass('active');
        $('body').css('overflow', 'auto');
    });

    // Close modal when clicking outside
    loginModal.on('click', function(e) {
        if (e.target === this) {
            $(this).removeClass('active');
            $('body').css('overflow', 'auto');
        }
    });

    // Toggle password visibility
    togglePassword.on('click', function() {
        const type = passwordInput.attr('type') === 'password' ? 'text' : 'password';
        passwordInput.attr('type', type);
        
        if (type === 'text') {
            $(this).removeClass('fa-eye').addClass('fa-eye-slash');
        } else {
            $(this).removeClass('fa-eye-slash').addClass('fa-eye');
        }
    });

    // Handle forgot password
    $('.forgot-password').on('click', function(e) {
        e.preventDefault();
        alert('Zabudnuté heslo - táto funkcia bude implementovaná neskôr');
    });
}

// Details Modal functions
function initializeDetailsModal() {
    const detailsTrigger = $('#detailsModalTrigger');
    const detailsModal = $('#detailsModal');
    const closeDetailsModal = $('#closeDetailsModal');

    // Open modal
    detailsTrigger.on('click', function(e) {
        e.preventDefault();
        detailsModal.addClass('active');
        $('body').css('overflow', 'hidden'); // Prevent background scroll
    });

    // Close modal
    closeDetailsModal.on('click', function() {
        detailsModal.removeClass('active');
        $('body').css('overflow', 'auto');
    });

    // Close modal when clicking outside
    detailsModal.on('click', function(e) {
        if (e.target === this) {
            detailsModal.removeClass('active');
            $('body').css('overflow', 'auto');
        }
    });
}
